import { render } from "./QRMBank.vue?vue&type=template&id=37cb82cf"
import script from "./QRMBank.vue?vue&type=script&lang=js"
export * from "./QRMBank.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__